import {
  PostComisionAnualidadCargaMetas,
  GetComisionAnualidadMetas
} from "../../../reducers/comisionAnualidad";

export interface ConfiguracionMetasStore
  extends PostComisionAnualidadCargaMetas,
    GetComisionAnualidadMetas {}

export const configuracionMetasStore: (
  state
) => ConfiguracionMetasStore = state => {
  const comisionAnualidadState = state.comisionAnualidad;

  return {
    cargaAnualidadMeta: comisionAnualidadState.cargaAnualidadMeta,
    postingCargaAnualidadMeta: comisionAnualidadState.postingCargaAnualidadMeta,
    postingCargaAnualidadMetaError:
      comisionAnualidadState.postingCargaAnualidadMetaError,

    comisionAnualidadMetas: comisionAnualidadState.comisionAnualidadMetas,
    gettingComisionAnualidadMetas:
      comisionAnualidadState.gettingComisionAnualidadMetas,
    gettingComisionAnualidadMetasError:
      comisionAnualidadState.gettingComisionAnualidadMetasError
  };
};
